// extracted by mini-css-extract-plugin
module.exports = {"heading":"FAQList_heading__fQW3D"};